export enum MediaFormatId {
    Undefined = 0,
    DASH = 2,
    HLS = 4,
}